<template>
  <div class="constrain my-24">
    <NuxtImg
      provider="storyblok"
      class="w-full h-full rounded-3xl object-cover max-h-[500px]"
      :src="blok.image.filename"
      :alt="getImageAlt(blok.image)"
      width="100%"
      loading="lazy"
      format="webp"
    />
  </div>
</template>
<script setup lang="ts">
const props = defineProps({ blok: Object });
const { getImageAlt } = useImageAlt();
</script>
